export const LocalStorageKeys = {
  LANGUAGE: 'language',
} as const;
